/**
 * Salas virtuales de Google Meet por nivel y grado
 * Colegio Bertolt Brecht
 */

export const MEET_LINKS = [
    {
        nivel: 'Primaria',
        icon: '🏫',
        color: 'primary',
        grados: [
            { grado: '1°', label: '1° Primaria', url: 'https://meet.google.com/tmx-oxcg-ort' },
            { grado: '2°', label: '2° Primaria', url: 'https://meet.google.com/vkt-jryw-urg' },
            { grado: '3°', label: '3° Primaria', url: 'https://meet.google.com/mdt-gweo-pkj' },
            { grado: '4°', label: '4° Primaria', url: 'https://meet.google.com/fnd-kkre-jjj' },
            { grado: '5°', label: '5° Primaria', url: 'https://meet.google.com/djb-onsy-fyc' },
            { grado: '6°', label: '6° Primaria', url: 'https://meet.google.com/okj-rkmh-ukf' },
        ],
    },
    {
        nivel: 'Secundaria',
        icon: '🎓',
        color: 'secondary',
        grados: [
            { grado: '1°', label: '1° Secundaria', url: 'https://meet.google.com/yfs-wviq-uki' },
            { grado: '2°', label: '2° Secundaria', url: 'https://meet.google.com/jkd-xufj-vfw' },
            { grado: '3°', label: '3° Secundaria', url: 'https://meet.google.com/jwb-wkhz-sxf' },
            { grado: '4°', label: '4° Secundaria', url: 'https://meet.google.com/qxr-rish-bet' },
            { grado: '5°', label: '5° Secundaria', url: 'https://meet.google.com/xgy-fjfi-oww' },
        ],
    },
];
